let initialized = false;

export function initGoogleTag() {
  const ga4 = process.env.REACT_APP_GA4_ID;
  if (!ga4 || initialized) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function () {
      window.dataLayer.push(arguments);
    };

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ga4)}`;
  document.head.appendChild(script);

  window.gtag("js", new Date());
  window.gtag("config", ga4);

  const adsId = process.env.REACT_APP_ADS_ID;
  if (adsId) window.gtag("config", adsId);

  initialized = true;
}

export function trackPurchase(order) {
  if (!window.gtag || !order || !order.id || !order.items?.length) return;

  const key = `ga_purchase:${order.id}`;
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, "1");

  const items = order.items.map((i) => ({
    item_id: i.slug,
    item_name: i.name,
    price: Number((i.line_total / i.qty).toFixed(2)),
    quantity: i.qty,
  }));
  const value = Number(order.total.toFixed(2));

  window.gtag("event", "purchase", {
    transaction_id: order.id,
    value,
    currency: "EUR",
    items,
  });

  const adsId = process.env.REACT_APP_ADS_ID;
  const adsLabel = process.env.REACT_APP_ADS_PURCHASE_LABEL;
  if (adsId && adsLabel) {
    window.gtag("event", "conversion", {
      send_to: `${adsId}/${adsLabel}`,
      value,
      currency: "EUR",
      transaction_id: order.id,
    });
  }
}
